import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { usePremium } from "@/context/PremiumContext";
import { Phone, Sparkles, Lock } from "lucide-react";

export default function VoiceScriptField({ value, onChange, testid }) {
  const { user } = useAuth();
  const { openUpgrade } = usePremium();
  const [tpl, setTpl] = useState([]);

  useEffect(() => {
    api.get("/voice-templates").then((r) => setTpl(r.data)).catch(() => {});
  }, []);

  return (
    <div className="border border-[var(--accent)]/30 bg-[var(--accent)]/5 p-3 space-y-2" data-testid="voice-field">
      <div className="flex items-center justify-between">
        <span className="label-mono text-[var(--text-2)] flex items-center gap-1.5">
          <Phone className="w-3.5 h-3.5" /> Voice script (text-to-speech)
        </span>
        {!user?.premium_active && (
          <button
            type="button"
            data-testid="voice-upgrade"
            onClick={openUpgrade}
            className="text-xs flex items-center gap-1 text-[var(--accent)] font-semibold hover:underline"
          >
            <Lock className="w-3 h-3" /> Premium
          </button>
        )}
      </div>

      {!user?.premium_active && (
        <p className="text-xs text-[var(--text-2)]">
          Automated voice calls are a Premium add-on ($15/mo). Set the script up now and{" "}
          <button type="button" onClick={openUpgrade} className="underline text-[var(--accent)] font-medium">
            upgrade
          </button>{" "}
          to place real calls.
        </p>
      )}

      <textarea
        data-testid={testid}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={3}
        placeholder="Good morning! This is your scheduled wake-up call."
        className="w-full px-3 py-2 border border-[var(--line)] bg-white outline-none focus:border-[var(--accent)]"
      />

      <div>
        <span className="text-xs text-[var(--text-2)] flex items-center gap-1">
          <Sparkles className="w-3 h-3" /> Quick templates
        </span>
        <div className="flex flex-wrap gap-1.5 mt-1.5">
          {tpl.map((t) => (
            <button
              key={t.id}
              type="button"
              data-testid={`voice-tpl-${t.id}`}
              onClick={() => onChange(t.text)}
              className="h-8 px-2.5 text-xs border border-[var(--line)] bg-white hover:border-[var(--accent)] hover:text-[var(--accent)] transition-colors"
            >
              {t.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
